// extracted by mini-css-extract-plugin
export default {"container":"SignUpBg_container__PBQb0","left":"SignUpBg_left__PbMog","right":"SignUpBg_right__k5FeN"};